import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import IProductType from './IProductType';
import { Table, Button } from 'react-bootstrap';
import ProductTypeListRow from './ProductTypeListRow';

interface IProductTypeListProps {
    items: IProductType[];
    beginEdit: (id: number) => void;
    delete: (id: number) => void;
    showLogs: (id: number) => void;
}

const ProductTypeList = (props: IProductTypeListProps) => {
    return (
        <Table responsive>
            <thead>
                <tr>
                    <th>{Translate('product-types/list/header/name')}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.items
                    .sort((a: IProductType, b: IProductType): number => (a.name < b.name ? -1 : 1))
                    .map((i: any) => {
                        return (
                            <ProductTypeListRow
                                productType={i}
                                key={i.id}
                                beginEdit={props.beginEdit}
                                delete={props.delete}
                                showLogs={props.showLogs}
                            />
                        );
                    })}
            </tbody>
        </Table>
    );
};

export default ProductTypeList;
